import { valueOf } from "@/types/common";

export const SETTING_TAB = {
  EMAIL_SETTING: "EMAIL_SETTING",
  MAINTENANCE_SETTING: "MAINTENANCE_SETTING",
};

export type TSettingTab = valueOf<typeof SETTING_TAB>;

export const SETTING_TAB_LABEL = {
  [SETTING_TAB.EMAIL_SETTING]: "通知設定",
  [SETTING_TAB.MAINTENANCE_SETTING]: "メンテナンスツール",
};
